import { onCLS, onFID, onLCP, onTTFB, onFCP } from "web-vitals";

const reportWebVitals = ({
  onPerfEntry,
}: { onPerfEntry?: (metric: any) => void } = {}): void => {
  if (onPerfEntry) {
    onCLS(onPerfEntry);
    onFID(onPerfEntry);
    onLCP(onPerfEntry);
    onFCP(onPerfEntry);
    onTTFB(onPerfEntry);
  }
};

export default reportWebVitals;
